// src/api/services/accountService.ts
import api from "../axios";

export interface AccountInfo {
  id: number;
  companyName: string;
  logoUrl: string | null;
}

export function getAccountInfo(slug: string) {
  return api.get<AccountInfo>(`/accounts/info/${encodeURIComponent(slug)}`);
}